module.exports = __webpack_public_path__ + "img/frb8m.dc337a83.jpg";